import React, {useEffect, useState} from "react"

import DatePicker from "react-datepicker";

import {format} from "date-fns"

const DateInput = (props) => {
    let date = props.value || props.selected || ""

    if(date){
        try{
            date = format(new Date(date), "yyyy-MM-dd")
        }catch(error){
            console.log(error, "ERROR")
        }
    }
    let minDate = props.minDate || props.min || ""
    console.log(minDate, "JJJJJ")

    if(minDate){
        try{
            minDate = format(minDate, "yyyy-MM-dd")
        }catch(error){
            console.log(error, "ERROR")
        }
    }

    let maxDate = props.maxDate || props.max || ""

    if(maxDate){
        try{
            maxDate = format(maxDate, "yyyy-MM-dd")
        }catch(error){
            console.log(error, "ERROR")
        }
    }

    return(
        <>
        {props.label && <label className=" text-xs">{props.label}</label>}
 <input
        // placeholder="Date"
        type="date"
        className="form-control"
        {...props}
        value={date}
        min={minDate}
        max={maxDate}
        onFocus={(e) => {
            try{
                e.target.showPicker()
            }catch(error){
                console.log(error, "ERROR")
            }
        }}
        placeholder={props.placeholder || props.label || ""}
        // placeholder={"ff"}
           
          />
        </>
       
    )
}

export default DateInput